import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import RoleUIsService from '../../components/services/RoleUIsService';

const useRoleUIsService = () => {
  return useMemo(() => new RoleUIsService(new ApiCalls()), []);
};

export default useRoleUIsService;
